import React from 'react'
import { auth } from '../firebase';

function Chat({item}) {
    var sent = item.uid === auth.currentUser.uid ? 'sent' : '';
    var name = item.uid === auth.currentUser.uid ? 'You' : `${item.name}`;
    return (
        <div className={`main-cont ${sent}`}>
            <div className="img-cont">
                <img src={item.photoUrl} />
            </div>
            <div className="msg-cont">
                <div className="name">{name}</div>
                <div className="msg">{item.msg}</div>
            </div>
        </div>
    )
}

export default Chat;
